<template>
  <div class="uk-position-relative uk-width-1-1">
    <span class="uk-form-icon">
      <i class="icon-user brand-cl"></i>
    </span>
    <input
        type="text" placeholder="Имя:" :value="value" class="uk-input fs14 fs16@m" @input="$emit('input', $event.target.value)"
        :class="{'uk-form-large': size === 'large'}"
      >
  </div>
</template>

<script>
  export default {
    props: ['value', 'size']
  }
</script>
